<template>
  <section class="ProfilePage">
    <div class="ProfilePage__actionList">
      <FormButton
        iconName="pencil"
        @click="openModal({name: RouteName.editProfile})"
      >
        Edit your profile
      </FormButton>

      <FormButton
        iconName="person"
        @click="handleViewProfileClick"
      >
        View your profile
      </FormButton>
    </div>

    <div class="ProfilePage__membership">
      <FormField label="Membership">
        <SupporterPortalButtonView />
      </FormField>
    </div>
  </section>
</template>

<script lang="ts" setup>
import FormButton from "@/components/FormButton.vue";
import FormField from "@/components/FormField.vue";
import { RouteName } from "@/lib/router/routes";
import useAuthStore from "@/stores/useAuthStore";
import useModalStore from "@/stores/useModalStore";
import usePlayerStore from "@/stores/usePlayerStore";
import SupporterPortalButtonView from "@/views/SupporterPortalButtonView.vue";
import { storeToRefs } from "pinia";

const {
  currentPlayer,
} = storeToRefs(useAuthStore());

const {
  openModal,
} = useModalStore();

const {
  viewPlayer,
} = usePlayerStore();

async function handleViewProfileClick () {
  if (!currentPlayer.value) return;

  viewPlayer(currentPlayer.value);
}
</script>

<style lang="scss" scoped>
.ProfilePage {
  position: relative;

  display: grid;
  grid: min-content min-content auto / auto;
  height: 100%;
  overflow-y: auto;
}

.ProfilePage__actionList {
  display: grid;
  gap: 12px;
  padding: 16px;

  border-bottom: solid 1px var(--themeColorNeutral100);
}

.ProfilePage__membership {
  padding: 24px 16px;
}
</style>
